module.exports = __webpack_public_path__ + "img/esh_yes.739735aa.png";